import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Popover } from 'antd';
import _ from 'lodash';
import BackgroundWrapper from './BackgroundWrapper';
import dates from 'react-big-calendar/lib/utils/dates';
import PopoverItem from './PopoverItem';
// const content = (
//   <div>
//     <p>Content</p>
//   </div>
// );

class TimeSlotGroup extends Component {
  static propTypes = {
    renderSlot: PropTypes.func,
    group: PropTypes.array.isRequired,
    resource: PropTypes.any,
    components: PropTypes.object,
    getters: PropTypes.object
  };

  timeSlotEventDetails = (slot, events) => {
    let empSlot = [];
    let employees = this.props.employees;

    let slotEvents = (events || []).filter(event =>
      // dates.inRange(event.start, slot, slotRangeEnd, 'hours')
      this.overlapTest(event.start, event.end, slot)
    );

    (slotEvents || []).forEach(event => {
      let empList = (employees || []).filter(
        emp => event.EmployeeID === emp.EmployeeAutoID
      );
      empSlot.push(_.head(empList));
    });

    return empSlot;
  };

  overlapTest = (start, end, timeSlot) => {
    const timeSlotEnd = dates.add(timeSlot, 1, 'hours');

    if (dates.lt(start, timeSlot)) {
      if (dates.lte(end, timeSlot)) {
        return false;
      } else {
        return true;
      }
    } else if (dates.gte(start, timeSlotEnd)) {
      return false;
    } else {
      return true;
    }
  };

  render() {
    const {
      renderSlot,
      resource,
      group,
      getters,
      daysEvents,
      slotMetrics,
      components: { timeSlotWrapper: Wrapper = BackgroundWrapper } = {}
    } = this.props;

    return (
      <div className="rbc-timeslot-group">
        {group.map((value, idx) => {
          const slotProps = getters ? getters.slotProp(value, resource) : {};
          const slotEventsDetail = this.timeSlotEventDetails(value, daysEvents);

          let content = <PopoverItem slotEventsDetail={slotEventsDetail} />;
          let addStyle = 'spanstyle';
          return (
            <Wrapper key={idx} value={value} resource={resource}>
              {slotEventsDetail.length > 0 ? (
                <Popover placement="rightTop" content={content} trigger="hover">
                  <div
                    {...slotProps}
                    className={cn(
                      'rbc-time-slot',
                      'reportcell',
                      slotProps.className
                    )}
                  >
                    {renderSlot &&
                      renderSlot(idx, slotEventsDetail, slotMetrics, addStyle)}
                  </div>
                </Popover>
              ) : (
                <div
                  {...slotProps}
                  className={cn(
                    'rbc-time-slot',
                    'reportcelldefault',
                    slotProps.className
                  )}
                >
                  {renderSlot && renderSlot(idx, slotEventsDetail, slotMetrics)}
                </div>
              )}
            </Wrapper>
          );
        })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    employees: state.roster.employeeList,
    branches: state.BranchReducer.branchList,
    departments: state.DepartmentReducer.departmentList
  };
}

export default connect(mapStateToProps)(TimeSlotGroup);
